import script from "./ProductDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductDetails.vue?vue&type=script&lang=ts&setup=true"

import "./ProductDetails.vue?vue&type=style&index=0&id=411dee70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-411dee70"]])

export default __exports__